import styled, { css, FlattenSimpleInterpolation } from 'styled-components'

import { Typography } from '../../../typography'

import { CrossCircle } from 'primsell-shared-layer/assets/icons'
import { FilterSelectedItemSizeT } from './filter-selected-item.types'

const itemSizeConfig: Record<FilterSelectedItemSizeT, FlattenSimpleInterpolation> = {
  sm: css`
    padding: 4px 6px;
    height: 30px;
    gap: 8px;
    border-radius: 6px;
  `,
  base: css`
    padding: 8px 10px;
    height: 40px;
    gap: 12px;
    border-radius: 8px;
  `,
}

export const FilterSelectedItem = styled.div<{ size?: FilterSelectedItemSizeT }>`
  border: 1px solid #e5e7eb;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 40px;
  max-width: 255px;

  ${({ size = 'base' }) => itemSizeConfig[size]}
`

export const Label = styled(Typography)`
  color: #6b7280;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`

export const Icon = styled(CrossCircle)`
  min-width: 20px;
  min-height: 20px;
`
